import axios from 'axios';
import { jsonLoginStatusesUrl } from '../config';

/**
 * GET LoginStatuses.
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {string} [props.cacheId=loginStatuses] - Override the default cacheId
 * @param {boolean} [props.globalCache=true] - Sets local cache on first call, pulls from cache on subsequent calls
 * @returns {Promise}
 */
const getLoginStatuses = (props = {}) => {
  const {
    cacheId = 'loginStatuses',
    globalCache = true,
    requestConfig
  } = props;

  const method = 'get';
  const url = jsonLoginStatusesUrl;

  // globalCache - not tested yet
  if (globalCache && globalCache[cacheId]) {
    return Promise.resolve(globalCache[cacheId]);
  }

  return axios({
    method,
    url,
    ...requestConfig
  });
};

export default getLoginStatuses;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/getLoginStatuses.js